<template>
  <div class="existing-account-arguments">
    <existing-account-argument image="padlock" title="Conteúdo liberado" text="Seu pequeno vai poder acessar todas as séries, livros e jogos que mais gosta." />
    <existing-account-argument image="clock" title="Controle dos pais" text="Não gosta de algum desenho? Controle o que seu pequeno assiste e por quanto tempo!" />
    <existing-account-argument image="wifi" title="Assista sem internet" text="Baixe os episódios favoritos do pequeno e assista quando e onde quiser!" />
    <existing-account-argument image="tv" title="Multiplataforma" text="Acesse sua conta em todas as plataformas disponíveis: Aplicativo, Web e Smart TV." />
  </div>
</template>

<script>
export default {
  name: 'existing-account-arguments'
}
</script>

<style lang="scss">
.existing-account-arguments {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  margin: 24px auto;
  max-width: 550px;

  @media only screen and (min-width: 470px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  @media only screen and (min-width: 992px) {
    max-width: 550px;
  }

  @media only screen and (min-width: 992px) {
    max-width: 550px;
  }

  @media only screen and (min-width: 1200px) {
    max-width: 650px;
  }
}
</style>
